import { form } from '../../../formState'

import { useTexts } from './hooks/useTexts'
import { useValidateEmail } from './hooks/useValidateEmail'

export function Email() {
  const texts = useTexts()
  const validateEmail = useValidateEmail()

  form.useAddFieldValidation('email', async (field, _formApi) => {
    const emailField = field.value

    if (emailField && emailField.status === 'exact' && emailField.value.length > 0) {
      const email = emailField.value

      const emailValid = await validateEmail(email)

      if (!emailValid) {
        return texts.invalidEmail
      }
    }
  })

  return (
    <form.BulkTextField
      name="email"
      mixedLabel={texts.mixed}
      label={texts.email}
      validateOn="blur"
    />
  )
}
